import React, { useContext, useState } from "react";
import Modal from "../../../Modal/Modal";
import Input from "../../../FormComponents/Input"
import { toastError, toastSuccess } from "../../../FormComponents/Toasts";

import FileDropzone from "../../../FormComponents/FileDropzone";
import { FileEarmarkPlus, ArrowLeft, Trash } from "react-bootstrap-icons";

export default function ClientContactModal({
  isOpen,
  setIsOpen,
  edit,
  editableContact,
  index,
  addToClientContacts,
  updateClientContacts,
  deleteClientContact
}) {
  const [src, setSrc] = useState(editableContact?.avatar && URL.createObjectURL(editableContact.avatar))
  const [contactName, setContactName] = useState(editableContact?.name || '')
  const [contactPhone, setContactPhone] = useState(editableContact?.phone || '')
  const [contactEmail, setContactEmail] = useState(editableContact?.email || '')
  const [contactNotes, setContactNotes] = useState(editableContact?.notes || '')
  const [contactAvatar, setContactAvatar] = useState(editableContact?.avatar || null)


  const handleAddUpdateSubmit = () => {
    const newContact = {
      name: contactName,
      phone: contactPhone,
      email: contactEmail,
      notes: contactNotes,
      avatar: contactAvatar,
    }

    if (edit) {
      updateClientContacts(newContact, index)
    } else {
      addToClientContacts(newContact)
    }

    setIsOpen(false)
  }

  const removeContact = () => {
    deleteClientContact(index)
  }

    // const formData = new FormData()
    // formData.append('client_contact[name]', clientContact.name)
    // formData.append('client_contact[email]', clientContact.email)
    // formData.append('client_contact[phone]', clientContact.phone)
    // formData.append('client_contact[notes]', clientContact.notes)
    // if (clientContact.file) formData.append('client_contact[avatar]', clientContact.file)

  return (
    <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
      <Modal.Body>
        <div>
          <div className="flex justify-between items-center pb-4">
            <h2>{edit ? 'Update Contact' : 'Create New Contact'}</h2>
            <Modal.DissmissButton className='flex items-center p-2'>
              <ArrowLeft className='mr-1 dark:text-white' /><span className='font-bold dark:text-white'>Back</span>
            </Modal.DissmissButton>
          </div>
          <div className="w-full">
            <Input noLabelPadding label="Name" placeholder="Name" name='name' onChange={(e) => setContactName(e.target.value)} defaultValue={editableContact && editableContact.name}/>
            <Input noLabelPadding label="E-mail address" placeholder="Email" name="email" onChange={(e) => setContactEmail(e.target.value)} defaultValue={editableContact && editableContact.email} />
            <Input noLabelPadding label="Phone number" placeholder="Phone" name='phone' onChange={(e) => setContactPhone(e.target.value)} defaultValue={editableContact && editableContact.phone} />
            {/* <div className={`w-full flex justify-center ${values.avatar?.url && 'py-6' || 'py-1'}`}>
              {values.avatar?.url && <img className="h-20 w-20 rounded-3xl" src={values.avatar.url} />}
            </div> */}
            <span className="label">Note</span>
            <textarea
              name='notes'
              placeholder="Write a note"
              rows="4"
              cols="40"
              className='
                mb-4
                border-1
                border-rb-lite-grey
                focus-visible:outline-0
                focus-visible:border-rb-green
                focus-visible:border-2
                focus:outline-0
                focus:ring-transparent
                focus:ring-offset-transparent
                ring-transparent
                ring-offset-transparent
                rounded-lg
                w-full
                dark:border-rb-dark-mode-lighter
                dark:bg-rb-dark-mode
                dark:text-white
                dark:placeholder-gray-400
                '
              onChange={(e) => setContactNotes(e.target.value)}
              defaultValue={editableContact && editableContact.notes}
            />
            <span className="label">Contact Avatar</span>
            <FileDropzone uploadFiles={files => {
              setSrc(URL.createObjectURL(files[0]))
              setContactAvatar(files[0])
            }}
              icon={<FileEarmarkPlus />}
            />
            <div className={`w-full flex justify-center ${src && 'py-6' || 'py-1'}`}>
              {src && <img className="h-20 w-20 rounded-3xl" src={src} />}
            </div>
            <div className="flex justify-between mt-5">
              <button
                className={`${edit ? '' : 'hidden '}flex items-center`}
                onClick={() => {
                  removeContact()
                  setIsOpen(false)
                }}
              >
                <Trash />
                <span className="ml-1">Delete contact</span>
              </button>
              <button
                type="button"
                className={`${edit ? '' : 'ml-auto '}submit text-white bg-rb-green border-2 rounded-lg px-4 py-2 text-center active:shadow-outer active:shadow-rb-green border-rb-green dark:text-rb-dark-mode dark:bg-rb-green dark:border-rb-green dark:active:shadow-outer dark:active:shadow-rb-green`}
                onClick={() => handleAddUpdateSubmit()}
              >
                {edit ? 'Update Contact' : 'Add contact'}
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

